import './Loader.css';
import PropTypes from 'prop-types';

function Loader({ size = '48px', color = 'light', className = '' }) {
    return (
        <div className={`okzou-secondary-loader ${color} ${className}`}>
            <span className="loader" style={{ width: size, height: size }}></span>
        </div>
    );
}

Loader.propTypes = {
    size: PropTypes.string,
    color: PropTypes.oneOf(['light', 'dark', 'accent']),
    className: PropTypes.string,
};

export default Loader;
